import { db } from "../firebaseConfig";
import {
  collection,
  getDocs,
  getDoc,
  deleteDoc,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

const isProtectedDiscussionDoc = (data = {}) =>
  data.isHidden === true || data.authorDeleted === true;

export async function postHasModeratedChildren(postId) {
  const postSnap = await getDoc(doc(db, "posts", postId));
  if (postSnap.exists() && postSnap.data()?.containsModeratedContent === true) {
    return true;
  }

  const basePath = `posts/${postId}`;
  const commentsSnap = await getDocs(collection(db, `${basePath}/comments`));

  for (const commentDoc of commentsSnap.docs) {
    if (isProtectedDiscussionDoc(commentDoc.data())) return true;

    const repliesRef = collection(db, `${basePath}/comments/${commentDoc.id}/replies`);
    const repliesSnap = await getDocs(repliesRef);
    if (repliesSnap.docs.some((replyDoc) => isProtectedDiscussionDoc(replyDoc.data()))) {
      return true;
    }
  }

  return false;
}

// Deletes replies -> comments -> seenBy -> post
export async function deletePostWithSubcollections(postId, options = {}) {
  const {
    preserveIfModerated = false,
    actorUid = "",
    actorName = "",
  } = options;

  if (preserveIfModerated && await postHasModeratedChildren(postId)) {
    await updateDoc(doc(db, "posts", postId), {
      isHidden: true,
      hiddenBy: actorUid,
      hiddenByName: actorName,
      hiddenReason: "Author deleted post while moderated content existed",
      hiddenAt: serverTimestamp(),
      authorDeleted: true,
      authorDeletedAt: serverTimestamp(),
      authorDeletedBy: actorUid,
      authorDeletedByName: actorName,
      containsModeratedContent: true,
    });
    return { preservedForModeration: true };
  }

  const basePath = `posts/${postId}`;

  // 1. DELETE REPLIES for every comment
  const commentsSnap = await getDocs(collection(db, `${basePath}/comments`));

  for (const commentDoc of commentsSnap.docs) {
    const repliesRef = collection(db, `${basePath}/comments/${commentDoc.id}/replies`);
    const repliesSnap = await getDocs(repliesRef);

    for (const replyDoc of repliesSnap.docs) {
      await deleteDoc(replyDoc.ref); // delete each reply doc
    }

    await deleteDoc(commentDoc.ref); // delete the parent comment doc
  }

  // 2. DELETE SEENBY subcollection (new view-tracking system)
  const seenBySnap = await getDocs(collection(db, `${basePath}/seenBy`));
  for (const seenDoc of seenBySnap.docs) {
    await deleteDoc(seenDoc.ref);
  }

  // 3. DELETE the actual post
  await deleteDoc(doc(db, "posts", postId));
  return { deleted: true };
}
